import { HTTP } from '../../../assets/js/axiosConfig'

const state = {
    maxRecords: 8,
    users: [],
    results: {
        totalRecords: 0,
        totalPages: 0
    },
    editIndex: null,
    deleteIndex: null
}
const mutations = {
    GET_USERS (state) {
        HTTP.get('api/users')
            .then((response) => {
                state.users = response.data
                state.results.totalRecords = response.data.length
                state.results.totalPages = Math.ceil(response.data.length / state.maxRecords)
            })
            .catch(err => console.log(err))
    },
    SET_INDEX (state, data) {
        state[data.name] = data.value
    },
    UPDATE_USER_LIST (state, payload) {
        if (payload.action === 'PUT') {
            state.users[payload.index] = payload.data
        } else if (payload.action === 'DELETE') {
            state.results.totalRecords -= 1
            state.results.totalPages = Math.ceil(state.results.totalRecords / state.maxRecords)
            state.users.splice(payload.index, 1)
        } else {
            state.results.totalRecords += 1
            state.results.totalPages = Math.ceil(state.results.totalRecords / state.maxRecords)
            state.users.push(payload.data)
        }
    }
}
const actions = {
    getUsers ({ commit }) {
        commit('GET_USERS')
    },
    setIndex ({ commit }, data) {
        commit('SET_INDEX', data)
    },
    updateUserList ({ commit }, payload) {
        commit('UPDATE_USER_LIST', payload)
    }
}
const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js